// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"501":"css/backend","887":"css/frontend"}[chunkId] + ".css";
};